import { render } from "./Product.vue?vue&type=template&id=1e85a173&scoped=true"
import script from "../js/product.js?vue&type=script&lang=js"
export * from "../js/product.js?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=1e85a173&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e85a173"]])

export default __exports__